import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import history from "history/browser";

import RightSide from './RightSide';
import Footer from './Footer';
import FileNotFound from './FileNotFound';

import tokenError from '../assets/img/token-error.svg';

import moment from "moment"

import "../assets/css/deposit.scss"
import {getApiUrl, gup} from "../utils/utils"

class WrongToken extends Component {
    constructor(props) {
        super(props)

        this.state = {
            sendFailed: false,
            newLink: false,
            disabled: false
        }

    }

    depositGenerateAndSendCode = async () => {

        if(this.props.openDepositNewLink){
            const openToken = gup("openToken")
            history.push(`/external/depositboxes?openToken=${openToken}`)
            return window.location.reload()
        }

        let headers = new Headers()
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                hash1: this.props.boxHash1,
                hash2: this.props.boxHash2,
                uh1: this.props.userHash1,
                uh2: this.props.userHash2
            })
        }

        await fetch(`${getApiUrl()}/api/external/depositboxes/resend/link`, requestOptions)
            .then((res) => {
                if(res.ok) {
                    this.setState({
                        newLink: true,
                        sendFailed: false
                    })
                }
                else {
                    this.setState({
                        sendFailed: true
                    })
                }
            })
            .catch((error) => {
                console.log("error : ", error);
            })
        /*if(this.state.disabled){
            return 0;
        }
        this.setState({disabled: true});
        const data = new FormData();
        data.append("boxHash1", this.props.boxHash1);
        data.append("boxHash2", this.props.boxHash2);
        data.append("emailToSendCode", this.props.emailsList[0]);
        data.append("uh", this.props.userHash1);
        data.append("uh2", this.props.userHash2);

        await api
            .post(`${BASE_URL}/apiV2.php/?depositGenerateAndSendCode`, data)
            .then(response => {
                if (response.data !== 0) {
                    this.setState({
                        sendFailed: true,
                        disabled: false
                    })
                }
                else {
                    this.setState({
                        newLink: true,
                        disabled: false
                    })
                }

                return response.data;
            })
            .catch(e => {
                throw e;
            });*/
    }

    render() {
        const { t } = this.props;
        const {
            boxCreationDate,
            boxName,
            boxToken,
            emailsList,
            whitemarkBackground,
            whitemarkBtnColor,
            whitemarkFavicon,
            whitemarkLogo,
            whitemarkTitle,
        } = this.props;


        const { sendFailed, newLink } = this.state;
        if (sendFailed === false) {
            return (
                <div className="main">
                    <Helmet>
                        <title>{whitemarkTitle}</title>
                        {<link rel="shortcut icon" href={whitemarkFavicon} />}
                        <style type="text/css">
                            {`
                                .main {
                                    background:url(${whitemarkBackground});
                                    background-size:cover;
                                    background-attachment: fixed;
                                }

                                .main>div.darker{
                                    background-color: rgba(32,32,48,0.7);
                                    min-height: 100vh;
                                }

                                .logo {
                                    background-image: url(${whitemarkLogo});
                                }

                                button.orangeBtn {
                                    background-color: ${whitemarkBtnColor};
                                }
                            `}
                        </style>
                    </Helmet>
                    <div className={/*whitemarkTitle === "LockSelf Deposit Box" ? "darker" :*/ "noDark"}>
                        <div className="mainContainerDeposit">
                            <div className="containerDeposit">
                                <div className="headerDeposit">
                                    <div className="logo"></div>
                                </div>
                                <div className="bodyDeposit">
                                    <div className="wrongToken">
                                        <div>
                                            <h3 className="senderLabel">{t("general.sender")}</h3>
                                            <div className="Card sender">
                                                {emailsList?.length > 0 &&
                                                    <>
                                                        <span>{emailsList[0].ownerFirstName.charAt(0) + emailsList[0].ownerLastName.charAt(0)}</span>
                                                        <span>
                                                            <h1>{emailsList[0].ownerFirstName + " " + emailsList[0].ownerLastName}</h1>
                                                        </span>
                                                    </>
                                                }

                                            </div>
                                        </div>
                                        <div className="shareLabel">
                                            <h2>{t("general.title")}</h2>
                                        </div>
                                        <div className="Central">
                                            <div className="Card tokenVs">
                                                <div className="boxInfo">
                                                    <h2>{boxName} <small>- {moment(boxCreationDate).format("LL")}</small></h2>
													<img className="center" src={tokenError} alt="logo" />
                                                    {/* {!boxDescription.length !== "" ? <span className="boxDescription">{boxDescription}</span> : <div></div>} */}
                                                </div>

                                                {newLink ? <p className="green">{t("depositBox.linkReceived")}</p> : <p>{t("depositBox.expiredTokenRule")}</p>}
                                                {newLink === false ? <button className="orangeBtn" disabled={this.state.disabled} onClick={e => this.depositGenerateAndSendCode(e)}>{t("depositBox.receiveLink")}</button> : null}
                                                {emailsList?.[0]?.email && (<p className="onEmail"><i>{t("general.on")}{emailsList?.[0]?.email}</i></p>)}
                                            </div>
                                            <div className="shareId">
                                                <span>#{boxToken}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <Footer />
                                </div>
                            </div>
                            <RightSide depositAvailable={true} />
                        </div>
                    </div>
                </div>
            )
        }
        else {
            return <FileNotFound whitemarkTitle={whitemarkTitle} whitemarkFavicon={whitemarkFavicon} whitemarkBackground={whitemarkBackground} whitemarkLogo={whitemarkLogo} />
        }
    }
}

export default withTranslation()(WrongToken)
